<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div>
  <v-dialog
    v-model="dialog"
    transition="dialog-bottom-transition"
    max-width="630"
    content-class="sc-modal sc-modal--md"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :color="$vuetify.theme.dark ? 'primary' : 'common_text'"
        class="inserirColabButton"
        text
        @click="dialog = true"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon class="mr-1">mdi-plus</v-icon>
        <strong> Nova noticía </strong>
      </v-btn>
    </template>

    <v-card v-if="dialog" flat class="sc-modal__card">
      <v-btn icon class="sc-modal__close" @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <!-- Header -->
      <div class="sc-modal__header">
        <v-icon color="primary" class="mr-3">mdi-newspaper-plus</v-icon>
        <div>
          <span class="sc-modal__title">Adicionar notícia</span>
          <span class="sc-modal__subtitle">Cadastre uma nova notícia para a produção</span>
        </div>
      </div>

      <!-- Form -->
      <div class="sc-modal__body">
        <div class="sc-modal__field">
          <label class="sc-modal__field-label">Título</label>
          <v-text-field
            solo
            flat
            dense
            background-color="surface_tertiary"
            placeholder="Digite o título da notícia"
            v-model="dsc_nome_colaborador"
            hide-details="auto"
          />
        </div>
        <div class="sc-modal__field">
          <label class="sc-modal__field-label">Texto</label>
          <v-textarea
            solo
            flat
            dense
            background-color="surface_tertiary"
            placeholder="Digite o texto da notícia"
            v-model="dsc_texto_colaboracao"
            rows="4"
            no-resize
            hide-details="auto"
          />
        </div>
        <div class="sc-modal__field">
          <label class="sc-modal__field-label">Mídia (opcional)</label>
          <div class="midiaWrapper">
            <div v-if="!selectedMidia" class="chooseMidia">
              <v-file-input
                class="inputIcon"
                hide-input
                clear-icon
                @change="onChangeImageOrVideo"
                color="icon_default"
                prepend-icon="mdi-file-image-plus"
                accept="image/png, image/jpeg, image/gif, image/jpg, image/tiff, video/mp4, video/ogg, video/webm"
              />
            </div>
            <template v-if="image_or_video_file !== null">
              <v-btn class="removerMidiaButton" small @click.prevent="limparInputImagem">
                <v-icon color="icon_default">mdi-delete</v-icon>
              </v-btn>
              <template v-if="image_or_video_type.includes('video')">
                <video
                  width="300"
                  height="150"
                  controls
                  v-if="url_image_or_video !== null"
                  :key="url_image_or_video"
                >
                  <source :src="url_image_or_video" type="video/mp4" />
                </video>
              </template>
              <template v-else-if="image_or_video_type.includes('image')">
                <img
                  v-if="url_image_or_video !== null"
                  :src="url_image_or_video"
                  alt="Imagem"
                  class="imgColaboracao"
                />
              </template>
            </template>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="sc-modal__footer">
        <v-btn text @click="close" class="modal-btn-cancel">Cancelar</v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          @click.prevent="inserirColaboracao"
          class="modal-btn-confirm"
        >
          <v-icon small class="mr-1">mdi-check</v-icon>
          Salvar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
  <ModalConfirmAction
    :visible="showConfirmDialog"
    title="Inserir colaboração"
    message="Deseja inserir essa colaboração?"
    confirm-text="Confirmar"
    confirm-color="primary"
    @confirm="confirmInserirColaboracao"
    @cancel="showConfirmDialog = false"
  />
  </div>
</template>

<script>
import { apiClient } from "@/services/api";
import { mapActions } from "vuex";
import ModalConfirmAction from "../ModalConfirmAction.vue";
// import uploadImagem from "@/assets/uploadImagem.svg"

export default {
  components: {
    ModalConfirmAction,
    // uploadImagem
  },
  data() {
    return {
      selectedMidia: false,
      selectedAvatar: false,
      dialog: false,
      dsc_nome_colaborador: "",
      dsc_texto_colaboracao: "",
      flg_sem_avatar: true,
      url_avatar: "",
      avatar_file: null,
      url_image_or_video: null,
      image_or_video_file: null,
      image_or_video_type: "",
      loading: false,
      showConfirmDialog: false,
      video_types: [
        "video/mp4",
        "video/ogg",
        "video/webm",
        "image/png",
        "image/jpeg",
        "image/gif",
        "image/jpg",
        "image/tiff",
      ],
    };
  },
  props: {
    cod_producao: Number,
    cod_pasta: Number,
  },
  methods: {
    ...mapActions({
      getColaboracoesAprovadas: "colaboracoes_aprovadas/getColaboracoesAprovadas",
    }),
    close() {
      this.$emit("close");
      this.dialog = false;
      this.clearFormData();
    },
    openChooseFileDialog() {
      const chooseMidiaElement = document.getElementsByClassName("chooseMidia");
      const vFIleInputElement = document.getElementById("uploadAvatar");
      chooseMidiaElement.onclick = function () {
        vFIleInputElement.click;
      };
    },
    onClick(e) {
      if (e.target.checked === true) {
        const elements = document.getElementsByClassName("imgCheckBox");
        for (let i = 0; i <= elements.length - 1; i++) {
          if (elements[i].id !== e.target.id) {
            elements[i].checked = false;
          }
        }
        return;
      }
    },
    onChange(e) {
      this.avatar_file = e;
      this.url_avatar = URL.createObjectURL(this.avatar_file);
      this.selectedAvatar = true;
      this.flg_sem_avatar = !this.flg_sem_avatar;
      e = null;
    },
    onChangeImageOrVideo(e) {
      this.image_or_video_file = e;
      this.url_image_or_video = URL.createObjectURL(this.image_or_video_file);
      const type = this.image_or_video_file.type.split("/");
      this.image_or_video_type = type[0];
      e = null;
      if (this.image_or_video_file) {
        this.selectedMidia = true;
      }
    },
    clearFormData() {
      this.avatar_file = null;
      this.flg_sem_avatar = true;
      this.dsc_nome_colaborador = "";
      this.dsc_texto_colaboracao = "";
      this.selectedAvatar = null;
      this.selectedMidia = null;
      this.url_avatar = null;
      this.url_image_or_video = null;
      this.image_or_video_file = null;
      this.image_or_video_type = null;
    },
    async getBucketImages(fileName, subpasta) {
      try {
        const response = await apiClient.get(
          `/getBucketImages?fileName=${fileName}&subpasta=${subpasta}`
        );

        if (response.status === 200) {
          return response.data.url;
        }
      } catch (error) {
        return error;
      }
    },
    async inserirColaboracao() {
      if (this.dsc_nome_colaborador.trim() === "") {
        this.$toast.error("Digite o nome do colaborador.");
        return;
      }

      if (this.dsc_texto_colaboracao.trim() === "") {
        this.$toast.error("Digite o texto da colaboração.");
        return;
      }

      if (!this.flg_sem_avatar && this.avatar_file === null) {
        this.$toast.error("Selecione um avatar.");
        return;
      }

      if (
        this.image_or_video_file !== null &&
        !this.video_types.includes(this.image_or_video_file.type)
      ) {
        this.$toast.error("Os arquivos suportados para vídeos são: .mp4, .ogg, .webm");
        this.image_or_video_file = null;
        return;
      }

      this.showConfirmDialog = true;
    },
    async confirmInserirColaboracao() {
      this.showConfirmDialog = false;
      try {
        this.loading = true;
        const dat_colaboracao = new Date();
        const miliseconds = dat_colaboracao.getMilliseconds();
        const dat_colaboracao_formatada = dat_colaboracao
          .toLocaleString("pt-BR", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
          })
          .replaceAll("/", "")
          .replaceAll(":", "")
          .replaceAll(" ", "");

        const id_colaboracao = String(this.cod_producao)
          .concat("-", dat_colaboracao_formatada)
          .concat("-", miliseconds)
          .replaceAll(",", "");

        let url_avatar_colaborador;
        let url_midia_colaboracao;
        let dsc_arquivo_gcp_avatar = null;
        let dsc_arquivo_gcp_imagem_or_video = null;

        if (this.avatar_file !== null) {
          const file_type = this.avatar_file.type.split("/");
          dsc_arquivo_gcp_avatar = id_colaboracao.concat(".", file_type[1]);
        }

        if (!this.flg_sem_avatar) {
          await apiClient
            .post(
              "/uploadFileToGCP",
              {
                file: this.avatar_file,
                subpasta: "avatares",
                fileName: dsc_arquivo_gcp_avatar,
              },
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .catch((error) => {
              console.error("ERRO upload avatar gcp: ", error);
              this.loading = false;
            });

          url_avatar_colaborador = await this.getBucketImages(
            dsc_arquivo_gcp_avatar,
            "avatares"
          );
        }

        const formData = {
          id_colaboracao,
          cod_producao: this.cod_producao,
          dsc_fonte_colaboracao: "socialcam",
          dsc_nome_colaborador: this.dsc_nome_colaborador,
          dsc_texto_colaboracao: this.dsc_texto_colaboracao,
          url_avatar_colaborador: !this.flg_sem_avatar ? url_avatar_colaborador : "",
          flg_sem_avatar: this.flg_sem_avatar === true ? "S" : "N",
          dat_colaboracao,
          dsc_arquivo_gcp: dsc_arquivo_gcp_avatar,
        };

        if (this.image_or_video_file !== null) {
          const file_type = this.image_or_video_file.type.split("/");
          dsc_arquivo_gcp_imagem_or_video = id_colaboracao.concat(".", file_type[1]);

          await apiClient
            .post(
              "/uploadFileToGCP",
              {
                file: this.image_or_video_file,
                subpasta: "colaboracoes",
                fileName: dsc_arquivo_gcp_imagem_or_video,
              },
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then(async () => {
              await apiClient.post(`/inserirColaboracao`, formData);
            })
            .catch((error) => {
              console.error("ERRO upload midia gcp: ", error);
              this.loading = false;
            });

          url_midia_colaboracao = await this.getBucketImages(
            dsc_arquivo_gcp_imagem_or_video,
            "colaboracoes"
          );

          let url_midia_thumbnail;

          if (file_type[0].includes("video")) {
            url_midia_thumbnail = await this.getBucketImages(
              id_colaboracao.concat(".", "png"),
              "colaboracoes/thumbnail"
            );
          } else {
            url_midia_thumbnail = url_midia_colaboracao;
          }

          await apiClient.post("/inserirImagemColaboracao", {
            id_colaboracao,
            id_imagem: id_colaboracao,
            dsc_tipo_midia_colaboracao: file_type[0],
            url_midia_colaboracao,
            url_midia_thumbnail,
            flg_selecionada: "S",
            dsc_arquivo_gcp: dsc_arquivo_gcp_imagem_or_video,
            dsc_extencao_midia: file_type[1],
          });
        } else {
          await apiClient.post(`/inserirColaboracao`, formData);
        }

        await this.getColaboracoesAprovadas({
          page: 1,
          size: 5,
          cod_producao: this.cod_producao,
          cod_pasta: this.cod_pasta,
        });
        this.$toast.success("Colaboração inserida com sucesso.");
        this.clearFormData();
      } catch (error) {
        this.loading = false;
        this.$toast.error("Erro ao inserir colaboração");
      } finally {
        this.loading = false;
        this.dialog = false;
      }
    },
    limparInputImagem() {
      this.url_image_or_video = 1;
      this.image_or_video_file = null;
      this.image_or_video_type = null;
      this.selectedMidia = false;
    },
    limparAvatarImagem() {
      this.avatar_file = null;
      this.url_avatar = null;
      this.flg_sem_avatar = true;
    },
  },
};
</script>

<style lang="scss" scoped>
// Modal structure comes from _modal.scss (sc-modal__*). This block only carries
// component-specific bits: the activator button and the media picker widget.
.inserirColabButton {
  strong {
    font-size: 0.8rem;
    font-weight: 700;
  }
}

.midiaWrapper {
  min-width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;

  .chooseMidia {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: center;
    justify-content: center;
    width: 140px;
    height: 102px;
    border: 1px dashed var(--v-icon_default-base);
    border-radius: var(--sc-radius-md);

    .inputIcon {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      align-self: center;
      width: 32px;
      height: 102px;
      margin: 0 !important;
      padding: 0 !important;

      .v-input__prepend-outer {
        margin-right: 0 !important;
      }
    }
  }
}

.removerMidiaButton {
  width: 6px !important;
  height: 22px !important;
  position: absolute;
  z-index: 1;
  background: var(--v-background_secondary-base);

  .v-icon {
    color: var(--v-icon_default-base) !important;
  }
}

.imgColaboracao {
  align-self: center;
  margin-top: 1rem;
  width: 88px;
  height: 100px;
  vertical-align: middle;
  border-radius: 0.5rem;
}
</style>
